import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { CustomIcons } from '@shared/models/custom-icons';
import { VkCardData } from '@shared/components/vk-card/models';
import { TranslateService } from '@ngx-translate/core';
import { tap } from 'rxjs/operators';
import { ServerLinks } from '@shared/services/server-links';
import { ServerLinkName } from '@shared/models/server-links-model';

@Component({
  selector: 'app-vk-card',
  templateUrl: './vk-card.component.html',
  styleUrls: ['./vk-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VkCardComponent implements AfterViewInit {
  public icons = CustomIcons;
  public locale: string;
  @Input() public post: VkCardData;
  public vkGroupLinkWall: string;
  public onLangChange$ = this.translateSerive.onLangChange.pipe(
    tap(value => {
      this.locale = value.lang.split('-')[0];
    })
  );
  @ViewChild('title') public title: ElementRef<HTMLElement>;
  @ViewChild('text') public text: ElementRef<HTMLElement>;
  public titleWidth = 0;
  public textWidth = 0;
  constructor(private translateSerive: TranslateService, private cdr: ChangeDetectorRef, private serverLink: ServerLinks) {
    this.vkGroupLinkWall = `${serverLink.getLink(ServerLinkName.VkGroupLinkWall)}`;
  }

  public ngAfterViewInit(): void {
    this.titleWidth = this.title?.nativeElement?.clientWidth;
    this.textWidth = this.text?.nativeElement?.clientWidth;
    this.cdr.detectChanges();
  }
}
